import styled from '@emotion/styled'

export const Icon = styled.div`
  color: #d4d8dd;
  font-size: 13px;
  display: inline-flex;
  flex-direction: column;
  align-self: center;
`
